import { useEffect, useState } from "react"
import axios from "axios"
import { config } from "Utils/config"


export function usePageImageUrl(businessId, pageId, uploadNumber = "", token,type="pageThumbnail") {
  const [url, setUrl] = useState("")
  let urlSet = `${config.API_URL}/images/${type}/${businessId}/${pageId}${uploadNumber}`

    if(type === "widgets" || type === "workingWidgets") {
        urlSet = `${config.API_URL}/images/${type}/${businessId}/${pageId}`
    }

   


  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await axios.get(
          urlSet,
          {
            headers: {
              "token": `${token}`,
            },
            responseType: "blob",
          }
        )

        const objectUrl = URL.createObjectURL(response.data)
        setUrl(objectUrl)
      } catch (err) {
        console.error("Image fetch failed", err)
      }
    }

    if (businessId && pageId && token) {
      fetchImage()
    }
  }, [businessId, pageId, uploadNumber, token])

  return url
}

const imageCache = new Map()

const CACHE_TTL_SUCCESS = 5 * 60 * 1000  // 5 min
const CACHE_TTL_ERROR = 30 * 1000         // 30 sec

function getCached(key) {
  const entry = imageCache.get(key)
  if (!entry) return undefined
  if (Date.now() > entry.expiresAt) {
    imageCache.delete(key)
    return undefined
  }
  return entry.url
}

function setCached(key, url, isError = false) {
  imageCache.set(key, {
    url,
    expiresAt: Date.now() + (isError ? CACHE_TTL_ERROR : CACHE_TTL_SUCCESS),
  })
}

const EMPTY_IMAGE_BLOB_URL = (() => {
  const byteCharacters = atob("iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGNgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=")
  const byteArrays = [new Uint8Array([...byteCharacters].map(c => c.charCodeAt(0)))]
  const blob = new Blob(byteArrays, { type: "image/png" })
  return URL.createObjectURL(blob)
})()

export async function getPageImageUrl(businessId, pageId, uploadNumber = "", token, type = "pageThumbnail") {
  const cacheKey = `${type}:${businessId}:${pageId}:${uploadNumber}`

  const cached = getCached(cacheKey)
  if (cached !== undefined) return cached

  const url = `${config.API_URL}/images/${type}/${businessId}/${pageId}${uploadNumber}`

  try {
    const response = await axios.get(url, {
      headers: { token },
      responseType: "blob",
    })

    const blobUrl = URL.createObjectURL(response.data)
    setCached(cacheKey, blobUrl)
    return blobUrl
  } catch (err) {
    console.warn(`[getPageImageUrl] Failed for ${url}`, err)
    setCached(cacheKey, EMPTY_IMAGE_BLOB_URL, true)
    return EMPTY_IMAGE_BLOB_URL
  }
}